// extracted by mini-css-extract-plugin
export default {"wrapper":"Buttons_wrapper__6Wp2d","icon":"Buttons_icon__DJJpI","text":"Buttons_text__nmfS8","active":"Buttons_active__+3Uu6"};